(() => {
  const C = window.MayLondonStyleCatalog, I = window.MayLondonI18n;
  if (!C || !I) return;
  document.querySelectorAll('[data-fitting-room]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const find = key => root.querySelector('[data-fitting-' + key + ']');
    const strings = JSON.parse(find('strings').textContent), t = key => strings[key] || key;
    let products = [], selected = null, photo = '', result = '', job = '', timer, busy = false, submitting = false, available = false, unlocked = false, uncertain = false, limit = 12, photoRevision = 0, selectionRevision = 0;
    const availableVariant = v => v.available && (!v.managed || v.policy === 'continue' || Number(v.inventory) > 0);
    const variant = () => selected?.variants.find(v => String(v.id) === find('variant').value);
    const message = key => { find('status').textContent = t(key); };
    const imageURL = value => {
      try { const url = new URL(value, location.origin); return url.protocol === 'https:' && url.hostname === 'cdn.shopify.com' || url.origin === location.origin ? url.href : ''; } catch (_) { return ''; }
    };
    async function api(path, {method = 'GET', body} = {}) {
      const response = await fetch('/apps/fitting-room/' + path, {
        method, credentials: 'same-origin', mode: 'same-origin', redirect: 'error', referrerPolicy: 'no-referrer', cache: 'no-store', signal: AbortSignal.timeout(65000),
        headers: {'Content-Type': 'application/json', 'X-Fitting-Request': '1'},
        body: body ? JSON.stringify(body) : undefined
      });
      const data = await response.json();
      if (!response.ok) throw Object.assign(new Error(data.error || 'unavailable'), {code: data.error, status: response.status});
      return data;
    }
    function controls() {
      find('generate').disabled = busy || uncertain || !available || !unlocked || !photo || !availableVariant(variant() || {}) || !find('consent').checked;
      find('access').hidden = unlocked;
      find('file').disabled = busy || uncertain;
      find('variant').disabled = busy || uncertain;
      find('consent').disabled = busy || uncertain;
      find('delete').disabled = submitting || (!photo && !job);
      find('canvas').setAttribute('aria-busy', String(busy));
      find('generate').lastChild.textContent = ' ' + t(busy ? 'generating' : 'generate');
      root.querySelectorAll('[data-fitting-view="result"]').forEach(el => el.disabled = !result);
    }
    function show(view = 'original') {
      const source = view === 'result' ? result : photo;
      find('preview').hidden = !source; find('empty').hidden = !!source;
      if (source) find('preview').src = source; else find('preview').removeAttribute('src');
      find('preview').alt = t(view);
      root.querySelectorAll('[data-fitting-view]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.fittingView === view)));
      find('download').hidden = !result;
      if (result) find('download').href = result; else find('download').removeAttribute('href');
    }
    function browse() {
      const list = find('products'), query = find('search').value.trim().toLocaleLowerCase();
      const matches = products.filter(p => p.title.toLocaleLowerCase().includes(query));
      list.replaceChildren();
      for (const p of matches.slice(0, limit)) {
        const button = document.createElement('button'), img = document.createElement('img'), title = document.createElement('span');
        button.type = 'button'; button.className = 'fitting-room__product'; button.dataset.handle = p.handle;
        button.setAttribute('aria-pressed', String(selected?.handle === p.handle)); button.disabled = busy || uncertain;
        img.src = imageURL(p.image); img.alt = ''; img.width = 160; img.height = 214; img.loading = 'lazy'; title.textContent = p.title;
        button.append(img, title, C.colours(p)); button.addEventListener('click', () => choose(p)); list.append(button);
      }
      if (!matches.length) list.textContent = t('empty');
      find('more').hidden = matches.length <= limit;
    }
    async function choose(product) {
      if (busy || uncertain) return;
      const revision = ++selectionRevision;
      selected = null; find('chosen').hidden = true; controls(); message('loading');
      try {
        const data = await C.product(product.handle);
        if (revision !== selectionRevision) return;
        selected = data.product || data;
        if (!Array.isArray(selected.variants)) throw new Error('invalid product');
        find('title').textContent = selected.title;
        const select = find('variant'); select.replaceChildren();
        const placeholder = new Option(t('choose_options'), ''); placeholder.disabled = true; select.add(placeholder);
        selected.variants.forEach(v => select.add(new Option(v.title + (availableVariant(v) ? '' : ' (' + t('variant_unavailable') + ')'), String(v.id))));
        [...select.options].slice(1).forEach((option, i) => option.disabled = !availableVariant(selected.variants[i]));
        select.value = selected.variants.length === 1 && availableVariant(selected.variants[0]) ? String(selected.variants[0].id) : '';
        const url = new URL(selected.url, location.origin);
        find('product-link').href = url.origin === location.origin ? url.href : I.route('products/' + selected.handle);
        find('chosen').hidden = false; find('image-note').hidden = !!variant()?.image;
        message(available ? 'ready' : 'unavailable');
      } catch (_) { selected = null; message('failed'); }
      browse(); controls();
    }
    async function connect() {
      try {
        const data = await api('status'); available = data.available === true;
        unlocked = data.unlocked === true;
        message(available ? 'ready' : 'unavailable'); find('retry').hidden = available;
      } catch (_) { available = false; message('unavailable'); find('retry').hidden = false; }
      controls();
    }
    async function catalogue() {
      try {
        const data = await C.catalogue(root.dataset.catalog || '/collections/women');
        products = data.products.filter(p => !p.hidden && p.image && ['dresses','sets','tops','knitwear','trousers','skirts','outerwear'].includes(p.category) && p.variants.some(availableVariant));
        browse();
      } catch (_) { message('failed'); find('retry').hidden = false; }
    }
    find('file').addEventListener('change', async () => {
      const revision = ++photoRevision, file = find('file').files[0];
      photo = ''; result = ''; find('consent').checked = false; show(); controls();
      if (!file) return;
      if (!['image/jpeg','image/png','image/webp'].includes(file.type) || file.size > 8 * 1024 * 1024) { message('invalid_photo'); return; }
      try {
        const bitmap = await createImageBitmap(file, {imageOrientation:'from-image'});
        if (bitmap.width < 256 || bitmap.height < 256 || bitmap.width * bitmap.height > 20000000) { bitmap.close(); throw new Error('dimensions'); }
        const canvas = document.createElement('canvas'), ratio = Math.min(1, 1600 / Math.max(bitmap.width, bitmap.height));
        canvas.width = Math.round(bitmap.width * ratio); canvas.height = Math.round(bitmap.height * ratio);
        canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height); bitmap.close();
        if (revision !== photoRevision) return;
        photo = canvas.toDataURL('image/jpeg', .9); canvas.width = canvas.height = 0;
        message(available ? 'ready' : 'unavailable'); show(); controls();
      } catch (_) { if (revision === photoRevision) message('invalid_photo'); }
    });
    async function poll(id, started = Date.now()) {
      if (job !== id) return;
      try {
        const data = await api('jobs/' + id);
        if (job !== id) return;
        if (data.state === 'completed' && /^data:image\/jpeg;base64,[A-Za-z0-9+/=]+$/.test(data.image || '')) {
          result = data.image; busy = uncertain = false; show('result'); controls(); browse(); message('result'); find('retry').hidden = true; return;
        }
        if (['failed','deleted','expired'].includes(data.state)) {
          busy = uncertain = false; message(data.state === 'failed' ? 'failed' : data.state); controls(); browse(); return;
        }
      } catch (_) { /* Read-only retries never create a second paid request. */ }
      if (Date.now() - started > 150000) {
        busy = false; uncertain = true; message('uncertain'); find('retry').hidden = false; controls(); return;
      }
      timer = setTimeout(() => poll(id, started), 2500);
    }
    find('generate').addEventListener('click', async () => {
      if (find('generate').disabled) return;
      busy = submitting = true; result = ''; show(); controls(); browse(); message('generating');
      const id = crypto.randomUUID(); job = id;
      try {
        await api('jobs', {method:'POST', body:{request_id:id, handle:selected.handle, variant_id:variant().id, person_image:photo, consent:true}});
        submitting = false; controls();
        if (job === id) poll(id);
      } catch (error) {
        submitting = false; controls();
        if (job !== id) return;
        if (error.status && error.status < 500) {
          if (error.code === 'access_required' || error.code === 'session_expired') { unlocked = false; find('access-status').textContent = t('access_required'); }
          busy = false; message(error.code === 'variant_unavailable' ? 'variant_unavailable' : 'failed'); controls(); browse();
        } else { uncertain = true; message('uncertain'); poll(id); }
      }
    });
    find('delete').addEventListener('click', async () => {
      const id = job;
      job = '';
      // Keep the server reference if deletion fails so it can be retried.
      clearTimeout(timer); photoRevision++; selectionRevision++; photo = ''; result = ''; find('file').value = ''; find('consent').checked = false; show();
      if (id) {
        busy = true; controls();
        try { await api('jobs/' + id, {method:'DELETE'}); }
        catch (error) { if (error.status !== 404) { job = id; busy = false; uncertain = true; message('delete_failed'); controls(); return; } }
      }
      job = ''; busy = uncertain = false; controls(); browse(); message('deleted');
    });
    find('retry').addEventListener('click', () => { if (uncertain && job) { busy = true; controls(); poll(job); } else { connect(); if (!products.length) catalogue(); } });
    find('access').addEventListener('submit', async event => {
      event.preventDefault(); find('unlock').disabled = true;
      try {
        const data = await api('unlock', {method:'POST', body:{code:find('code').value}});
        unlocked = data.unlocked === true;
        find('access-status').textContent = t(unlocked ? 'unlocked' : 'invalid_code');
        if (unlocked) { find('code').value = ''; message('unlocked'); }
      } catch (error) {
        unlocked = false; find('access-status').textContent = t(['invalid_code','too_many_attempts'].includes(error.code) ? error.code : 'unavailable');
      } finally { find('unlock').disabled = false; controls(); }
    });
    find('consent').addEventListener('change', controls);
    find('variant').addEventListener('change', () => { find('image-note').hidden = !!variant()?.image; controls(); });
    find('search').addEventListener('input', () => { limit = 12; browse(); });
    find('more').addEventListener('click', () => { limit += 12; browse(); });
    root.querySelectorAll('[data-fitting-view]').forEach(button => button.addEventListener('click', () => show(button.dataset.fittingView)));
    addEventListener('pagehide', () => { clearTimeout(timer); photoRevision++; photo = result = ''; show(); });
    connect(); catalogue();
  });
})();
